import { sel } from '../utils'
// import parser from 'any-date-parser'

export default function countDown() {
  const timer$ = sel('[countdown-timer]')
  const timeString = timer$?.getAttribute('countdown-timer')
  if (!timeString) return
  const countDownDate = new Date(timeString).getTime()
  if (isNaN(countDownDate)) return
  // format: 3/1 2026
  // console.log('Countdown date:', countDownDate)

  const day$ = sel('[timer-day]')
  const hour$ = sel('[timer-hour]')
  const minute$ = sel('[timer-minute]')
  const second$ = sel('[timer-second]')
  const x = setInterval(() => {
    const now = new Date().getTime()
    const distance = countDownDate - now
    const days = Math.floor(distance / (1000 * 60 * 60 * 24))
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((distance % (1000 * 60)) / 1000)
    day$.textContent = days.toString().padStart(2, '0')
    hour$.textContent = hours.toString().padStart(2, '0')
    minute$.textContent = minutes.toString().padStart(2, '0')
    second$.textContent = seconds.toString().padStart(2, '0')
    if (distance < 0) {
      clearInterval(x)
      day$.textContent = '00'
      hour$.textContent = '00'
      minute$.textContent = '00'
      second$.textContent = '00'
    }
  }, 1000)
}
